<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" id="starDate"   format="dd.MM.yyyy" type="date" :clearable="false" v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy"   type="date" :clearable="false" v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('Məsul_şəxs')"
 :value="4"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search" @click="getData"></el-button>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        <el-table ref="elTable" v-loading="loading"  :data="displayData.filter(
          (data) =>
            !search ||
            data.claimNumber
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())
        )
          " style="width: 100%">
          >


          <el-table-column :label="$t('İş_#')" prop="dispClaimNumber">
          </el-table-column>


          <el-table-column label="DQN #" prop="regNumber">
          </el-table-column>

          <el-table-column :label="$t('Qiymətləndirici')" prop="techExpertUserName">
          </el-table-column>

          <el-table-column :label="$t('İcraçı')" prop="clientServiceUserName">
          </el-table-column>

          <el-table-column :label="$t('F4')" width="100">
            <template slot-scope="scope">
              <status-label :type="scope.row.form4Status === 1 ? 'green' : 'red'" />
              {{ scope.row.form4Status === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>
          


          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.accidentId, 'accident')" style="padding: 0 !important" size="mini">
               
                <div class="square-icon"> <i title="Ümumi statuslar" class="fa-solid fa-timeline"></i></div>

              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button title="Əməliyyatlara keçid" @click="handleEdit(scope.row.id)" style="padding: 0 !important"
                size="large">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="filter.page"
            :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize" layout="sizes, prev, pager, next"
            :total="this.data.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <accident-status-view ref="accident" />
  </div>
</template>
<script>
// import Assessments from "../components/Assessments.vue";
import AccidentStatusView from "../components/AccidentStatusView.vue";
import { GetApprasialForCallCenter } from "src/services/claim";
import { DateTimeToString, AddMonths, AddDays } from "../../services/helper";
import StatusLabel from "../components/StatusLabel.vue";
export default {
  data() {
    return {
      loading: false,
      showModal: false,
      data: [],
      search: "",
      act: [],
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        uid : null
      },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },
      uid: this.$store.state.user.id,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  components: {
    // Assessments,
    AccidentStatusView,
    StatusLabel
  },
  methods: {
    handleEdit(id) {
      this.$router.push({
        path: "claim/" + id,
      });
    },
    handleStatusView(id, type) {
      this.$refs["accident"].view(id, type);
    },
    getData() {
      this.loading = true;
      this.item.commandUserId = this.uid;
      this.item.startDate = DateTimeToString(this.item.startDate);
      this.item.endDate = DateTimeToString(this.item.endDate);
      this.item.uid = this.uid;
      GetApprasialForCallCenter(this.item).then((response) => {
        this.loading = false;
        if (response.data) {
          this.data = response.data;
          this.getDisplayData();  
        }
      });
    },
    getDisplayData() {
      this.displayData = this.data.slice((this.filter.page - 1) * this.filter.pagesize, this.filter.page * this.filter.pagesize)
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getDisplayData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getDisplayData();
    },
    loadTime() {
      this.item.startDate = AddDays(new Date(), -7);
      this.item.endDate = new Date();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
